import { blur } from "@cloudinary/url-gen/actions/effect"
import { crop, Resize } from "@cloudinary/url-gen/actions/resize"
import { useEffect, useState } from "react"

import { CuratedContentPageQuery } from "../../generated/graphql"
import { appStore } from "../../store/AppStore"
import { ArrayElement } from "../../types"
import { ccFactor, s } from "../../utilities/common"

// since the API also introduces random types, we need to only filter those we are using at any given time in the parent
// FIXME removed playlist type in parent / remove it here again after including playlists
export type FilteredBannerItem = ArrayElement<
  CuratedContentPageQuery["curatedContentPage"]["stageSlider"]
>["item"]

export const useBanner = (
  data: ArrayElement<
    CuratedContentPageQuery["curatedContentPage"]["stageSlider"]
  >,
) => {
  const item = data.item as FilteredBannerItem
  const cld = appStore((state) => state.cld)
  const [image, setImage] = useState<string>()
  const [albumImage, setAlbumImage] = useState<string>()
  const [title, setTitle] = useState<string>()
  const [subtitle, setSubtitle] = useState<string>()

  useEffect(() => {
    setTitle(
      item.__typename !== "Artist" &&
        item.__typename !== "Partner" &&
        item.__typename !== "Group" &&
        item.__typename !== "EditorialPlaylist"
        ? item?.title
        : item.__typename === "EditorialPlaylist"
          ? data.title
          : item.name,
    )
    const isAlbum =
      item.__typename === "Album" || item.__typename === "EditorialPlaylist"

    setSubtitle(
      item.__typename === "Artist"
        ? item.roles.map((role) => role.displayName).join(", ")
        : data.subtitle,
    )

    const url = item?.pictures?.filter(
      (i) => i.type === (isAlbum ? "COVER" : "TEASER"),
    )[0]?.url

    if (url) {
      const temp = cld
        .image(url)
        .resize(Resize.scale().width(s(ccFactor(992), true)))

      const res = isAlbum
        ? temp
            .resize(
              crop()
                .width(s(ccFactor(992), true))
                .height(s(ccFactor(558), true)),
            )
            .effect(blur().strength(2000))
        : temp
      setImage(res.format("jpg").setDeliveryType("fetch").toURL())
      setAlbumImage(
        isAlbum
          ? cld
              .image(url)
              .resize(Resize.scale().width(s(ccFactor(405), true)))
              .format("jpg")
              .setDeliveryType("fetch")
              .toURL()
          : undefined,
      )
    } else {
      setAlbumImage(undefined)
      setImage(undefined)
    }
  }, [data])

  return { image, albumImage, title, subtitle }
}
